import React from "react";

import PBRControls from "./PBRControls";

import HatchingControls from "./HatchingControls";

import ToonControls from "./ToonControls";

import GoochControls from "./GoochControls";

import HalftoneControls from "./HalftoneControls";

import OutlineControls from "./OutlineControls";

export default function TechniqueControls({
  technique,
  Panel,
  Slider,

  pbr,
  hatching,
  toon,
  gooch,
  halftone,
  outline,
}) {
  switch (technique) {
    case "pbr":
      return (
        <Panel title="PBR">
          <PBRControls Slider={Slider} {...pbr} />
        </Panel>
      );

    case "hatching":
      return (
        <Panel title="HATCHING">
          <HatchingControls Slider={Slider} {...hatching} />
        </Panel>
      );

    case "toon":
      return (
        <Panel title="TOON">
          <ToonControls Slider={Slider} {...toon} />
        </Panel>
      );

    case "gooch":
      return (
        <Panel title="GOOCH">
          <GoochControls Slider={Slider} {...gooch} />
        </Panel>
      );

    case "halftone":
      return (
        <Panel title="HALFTONE">
          <HalftoneControls Slider={Slider} {...halftone} />
        </Panel>
      );

    case "outline":
      return (
        <Panel title="OUTLINE">
          <OutlineControls Slider={Slider} {...outline} />
        </Panel>
      );

    default:
      return null;
  }
}
